import { render, staticRenderFns } from "./offer-management.vue?vue&type=template&id=0fcf5fb4&scoped=true&"
import script from "./offer-management.vue?vue&type=script&lang=js&"
export * from "./offer-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf5fb4",
  null
  
)

export default component.exports